export default class ApplicationMessageModel {
  public key!: number;
  public Show!: boolean;
  public MessageType!: string;
  public Message!: string;
}
